import { useState, useEffect } from "react";

const STORAGE_KEY = "lootspot_show_unused_markers";

export function useHideUnusedMarkers() {
  const [showUnused, setShowUnused] = useState(() => {
    const val = localStorage.getItem(STORAGE_KEY);
    return val === null ? true : val === "true";
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, showUnused);
  }, [showUnused]);

  // Helper to force show all (for reset)
  const forceShowAll = () => setShowUnused(true);

  return { showUnused, setShowUnused, forceShowAll };
}
